import '../../css/base.css';

const Bedrooms = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Bedrooms</h2>
      <p className="your-stay-text">The cottage consists of two double bedrooms, a further small bedroom
                                    houses a single bed which pulls out into a double (suitable for children).
                                    All rooms have plenty of storage space. Additional linen available on
                                    request. * NOTE: DUE TO COVID 19 SAFER STAYS GUIDANCE WE HAVE SADLY HAD TO
                                    REMOVE THE GAMES AND PUZZLES.
      </p>
    </div>
  );
}

export default Bedrooms;